import r, { useState as d } from "react";
import { useTranslation as p } from "react-i18next";
import { Loading as u } from "../../common/components/Loading/Loading.js";
import { Modal as y } from "../../common/components/Modal/Modal.js";
import { shouldShowProcessingOverlay as f, PaymentStatusKind as g } from "../hooks/paymentStatus.js";
import { usePaymentMethod as S } from "../hooks/usePaymentMethod.js";
import P from "./processingPaymentScreen.module.scss.js";
function b({
  design: o,
  paymentStatus: i,
  keepOverlayOnSuccess: s = !1,
  texts: e,
  children: m
}) {
  const { t } = p(), n = S(), a = i ?? (n == null ? void 0 : n.paymentStatus);
  if (!a)
    throw new Error("ProcessingPaymentScreen requires a paymentStatus prop or a PaymentMethodContext provider");
  const [c, l] = d(!1);
  return /* @__PURE__ */ r.createElement(r.Fragment, null, f(a, s) && /* @__PURE__ */ r.createElement(
    u,
    {
      fullScreen: !0,
      design: o && {
        color: o.textColor,
        backgroundColor: o.backgroundColor
      },
      text: (e == null ? void 0 : e.processing) || t("payments.redirect.verifying") || ""
    }
  ), /* @__PURE__ */ r.createElement(
    y,
    {
      design: o,
      show: a.kind === g.FAILED && !c,
      showCloseBtn: !0,
      onClose: () => l(!0),
      title: (e == null ? void 0 : e.errorTitle) || t("payments.redirect.errorTitle") || ""
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: P.processingPaymentScreen,
        "data-testid": "processing-payment-screen"
      },
      /* @__PURE__ */ r.createElement("div", { "data-testid": "processing-payment-error" }, (e == null ? void 0 : e.error) || t("payments.redirect.error")),
      m
    )
  ));
}
export {
  b as ProcessingPaymentScreen
};
//# sourceMappingURL=ProcessingPaymentScreen.js.map
